// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saveAndFinishLaterButton {
  clear: right;
  float: right;
  margin-top: 20px;
  margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/pages/refereeSaved/RefereeSaved.less"],"names":[],"mappings":"AAEA;EACC,YAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AADD","sourcesContent":["@import (reference) '../../constants.less';\n\n.saveAndFinishLaterButton {\n\tclear: right;\n\tfloat: right;\n\tmargin-top: 20px;\n\tmargin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
